import { EventUpdate } from "../../../admin/data-access/models/eventUpdate.model";
import { EventDetails } from "../../data-access/models/eventDetails.model";
import { evaluateRules } from "./evaluateRules.function";
import { EventStatus, EventsTitles } from "../../../admin/enums/eventsMessages";
import { RulesEnum } from "../../enums/rulesEnum";

export function isEventComplete(event: EventDetails, payload: EventUpdate): boolean {
  const isDraft = evaluateRules({ event: event, payload }, [
    { property: 'event.eventStatus', operator: RulesEnum.EQUALS, value: EventStatus.DRAFT }]);

  const imagePresent = evaluateRules({ event: event, payload }, [
    { property: 'event.eventImage', operator: RulesEnum.NOT_EQUALS, value: EventsTitles.NOT_AVAILABLE }]) ||
    evaluateRules({ event: event, payload }, [{ property: 'payload.eventImage', operator: RulesEnum.TRUTHY }]);

  const inviteesPresent = evaluateRules({ event: event, payload }, [
    { property: 'event.invitees', operator: RulesEnum.ARRAY_NOT_EMPTY }]) ||
    evaluateRules({ event: event, payload }, [{ property: 'payload.invitees', operator: RulesEnum.ARRAY_NOT_EMPTY }]);

  return isDraft && imagePresent && inviteesPresent;
}
